import * as bootstrap from "bootstrap";
import { hide, unhide } from "../../utils";
import { EventBus, Events } from "../eventBus";
import {
  anchorContentMightExceedBounds,
  getAnchorCategory,
  getAnchorIcon,
  getAnchorLongDescription,
  getCategoryColour,
} from "./anchors";
import { ElemID } from "./constants";
import { wayfinderGetPageOffset } from "./wayfinder";
import { getCurrentScale } from "./zoom";

const pageContainerWrapper = document.getElementById(
  ElemID.EDITOR_PAGE_CONTAINER_WRAPPER,
);
const anchorPanel = document.getElementById("anchor-sidebar-panel");
const sidebarHeading = document.getElementById("anchor-sidebar-heading-text");
const longDescriptionSpan = document.getElementById(
  "anchor-sidebar-description-text",
);
const locationSpan = document.getElementById("anchor-sidebar-location-text");
const locateButton = document.getElementById("anchor-sidebar-locate-button");
const deleteButton = document.getElementById("anchor-sidebar-delete-button");
let activeAnchorId = null; // track current id. used for delete action

export function initSidebar() {
  EventBus.subscribeAll(
    [Events.ANCHOR_CLICKED, Events.ANCHOR_ADDED],
    function (payload) {
      showAnchorPanel(payload.anchorId);
    },
  );

  EventBus.subscribeAll(
    [Events.PAGE_CONTAINER_CLICKED, Events.ANCHOR_DELETED],
    hideAnchorPanel,
  );

  deleteButton.addEventListener("click", deleteAnchor);
  locateButton.addEventListener("click", locateAnchor);
}

function deleteAnchor() {
  const element = activeAnchorId && document.getElementById(activeAnchorId);
  if (element) {
    EventBus.emit(Events.ANCHOR_DELETED, {
      anchorId: element.id,
      page: element.dataset.parentPage,
    });
    element.remove();
  }
}

function hideAnchorPanel() {
  resetActiveAnchor();
  // hide(anchorPanel);
  anchorPanel.classList.remove("slide-in");
}

function showAnchorPanel(anchorId) {
  const anchorElement = populateAnchorPanel(anchorId);
  if (anchorElement) {
    setActiveAnchor(anchorId);
    // unhide(anchorPanel);
    anchorPanel.classList.add("slide-in");
  }
}

function populateAnchorPanel(anchorId) {
  const element = document.getElementById(anchorId);
  const lengthAlert = document.getElementById(
    "anchor-sidebar-field-length-alert",
  );
  const categoryLabel = document.getElementById(
    "anchor-sidebar-category-label",
  );

  if (element) {
    const anchorName = element.dataset.anchor;
    const pageNum = element.dataset.parentPage;
    const anchorText = element.dataset.anchorText;
    const icon = getAnchorIcon(element.dataset.anchor);
    const longDescription = getAnchorLongDescription(anchorName);
    const category = getAnchorCategory(anchorName);
    const categoryColour = getCategoryColour(category);

    if (anchorContentMightExceedBounds(anchorName)) {
      unhide(lengthAlert);
    } else {
      hide(lengthAlert);
    }

    sidebarHeading.innerHTML = `<i class="bi ${icon}"></i> ${anchorText}`;

    categoryLabel.style.backgroundColor = categoryColour.bg;
    categoryLabel.style.color = categoryColour.text;
    categoryLabel.textContent = category;

    longDescriptionSpan.textContent = longDescription;
    locationSpan.textContent = `Page ${pageNum}`;
  }

  return element;
}

function setActiveAnchor(anchorId) {
  /** this affects styling as well as make it the target of deletion **/

  // first deactivate previous anchor if activated
  resetActiveAnchor();

  // activate new one
  const element = document.getElementById(anchorId);
  if (element) {
    activeAnchorId = anchorId;
    element.classList.add("anchor-active-in-sidebar");
  }
}

function resetActiveAnchor(anchorId) {
  const element = activeAnchorId && document.getElementById(activeAnchorId);
  if (element) {
    element.classList.remove("anchor-active-in-sidebar");
  }
  activeAnchorId = null;
}

function locateAnchor() {
  const element = activeAnchorId && document.getElementById(activeAnchorId);

  if (element) {
    scrollToAnchorIfNotVisible(activeAnchorId);
    highlightAnchor(activeAnchorId);
  }
}

function scrollToAnchorIfNotVisible(anchorId) {
  const anchor = anchorId && document.getElementById(anchorId);
  const scale = getCurrentScale("editor");
  if (anchor) {
    const pageIndex = Number(anchor.dataset.parentPage) - 1;
    const pageOffset = wayfinderGetPageOffset(pageIndex, scale);
    const containerRect = pageContainerWrapper.getBoundingClientRect();

    const elementStyle = window.getComputedStyle(anchor);
    const scaledWidth = parseInt(elementStyle.width);
    const scaledHeight = parseInt(elementStyle.height);

    // work out position of anchor relative to parentContainer
    // Anchors are placed at 0,0 or their parent page and translated to deltaX, deltaY
    const anchorTop = pageOffset.top + Number(anchor.dataset.deltaY);
    const anchorLeft = pageOffset.left + Number(anchor.dataset.deltaX);
    const anchorWidth = scaledWidth;
    const anchorHeight = scaledHeight;
    const anchorBottom = anchorTop + anchorHeight;
    const anchorRight = anchorLeft + anchorWidth;

    // First, check if anchor is fully visible. If it is, do not scroll.
    if (
      anchorTop >= pageContainerWrapper.scrollTop &&
      anchorBottom <= pageContainerWrapper.scrollTop + containerRect.height &&
      anchorLeft >= pageContainerWrapper.scrollLeft &&
      anchorRight <= pageContainerWrapper.scrollLeft + containerRect.width
    ) {
      return;
    }

    // work out midpoint of anchor
    const anchorMidpointX = anchorLeft + anchorWidth / 2;
    const anchorMidpointY = anchorTop + anchorHeight / 2;

    // try to place the anchor in the middle of the editor component
    const scrollTop = anchorMidpointY - containerRect.height / 2;
    const scrollLeft = anchorMidpointX - containerRect.width / 2;

    pageContainerWrapper.scrollTop = Math.max(scrollTop, 0);
    pageContainerWrapper.scrollLeft = Math.max(scrollLeft, 0);
  }
}

function highlightAnchor(anchorId) {
  const duration = 1000;
  const anchor = anchorId && document.getElementById(anchorId);
  if (anchor) {
    const tooltip = new bootstrap.Tooltip(anchor, {
      html: true,
      title: "&#x1F44B; It's here!",
      customClass: "anchor-location-tooltip",
      delay: {
        show: 0,
        hide: duration,
      },
    });
    tooltip.show();
    setTimeout(function () {
      tooltip.dispose();
    }, duration);
  }
}
